<template>
  <div id="app">
    <div class="body-container">
      <div class="body-header" v-if="$route.meta.keepAlive">
        <head-nav class="show-computer"></head-nav>
        <mobile-head-nav class="show-mobile"></mobile-head-nav>
      </div>
      <div class="body-content">
        <router-view></router-view>
      </div>
      <div class="body-footer" v-if="$route.meta.keepAlive">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNav from "@/components/headNav";
import MobileHeadNav from "@/components/MobileHeaderNav";
import Footer from "@/components/footer";
import router from "@/router";
export default {
  name: "App",
  components: { HeadNav, Footer, MobileHeadNav },
  data() {
    return {
      token: this.$store.state.token,
      menuTitle: ""
    };
  },
  mounted() {
    if (!this.token) {
      router.push({ path: "/login" });
    }
  },

  watch: {}
};
</script>

<style scoped lang="scss">
#app {
  overflow: hidden;
}
.body-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-content {
    flex: 1;
    overflow: auto;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue